export default __webpack_public_path__ + "static/media/featured_tour_09.4fae6a32.png";